import { render, staticRenderFns } from "./merge_widget.vue?vue&type=template&id=f3acaf74"
import script from "./merge_widget.vue?vue&type=script&lang=js"
export * from "./merge_widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports